import type { Organization } from './api';

export const homeProjectScopes = [
  { id: 1, label: 'Проекты университета', name: 'КБГУ', icon: 'GraduationCap' },
  { id: 2, label: 'Проекты института', name: 'ИЭРиИИ', icon: 'Buildings' },
  { id: 6, label: 'Проекты лаборатории', name: 'ЛИСАД', icon: 'Microscope' },
] as const;

export function parseProjectOrganization(value: string | null): number | null {
  if (!value || !/^[1-9]\d*$/.test(value)) return null;
  const id = Number(value);
  return Number.isSafeInteger(id) && id <= 2147483647 ? id : null;
}

export function getProjectOrganizationIds(organizations: Organization[], root: number): Set<number> {
  const ids = new Set<number>();
  if (!organizations.some(item => Number(item.id) === root)) return ids;
  const children = new Map<number, number[]>();
  for (const item of organizations) {
    const parent = Number(item.parent_id);
    children.set(parent, [...(children.get(parent) || []), Number(item.id)]);
  }
  const pending = [root];
  while (pending.length) {
    const id = pending.pop()!;
    if (ids.has(id)) continue;
    ids.add(id);
    pending.push(...(children.get(id) || []));
  }
  return ids;
}
